export default "__VITE_ASSET__ndRac07J__"